import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormConfiguration, enmEFormViewModes } from '../../../../shared-components/e-forms/e-form-config.model';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';
import { EFormDesignerService } from '../../../../shared-components/e-forms/e-form-designer/e-form-designer.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EFormDesignerComponent } from '../../../../shared-components/e-forms/e-form-designer/e-form-designer.component';
import { LoginService } from '../../../../shared-modules/login/login.service';
import {take } from 'rxjs/operators';
import { CustomDesignPage } from '../../../../admin360/customization/models/custom-design-page.model';
import { CustomizationService } from '../../../../admin360/customization/customization.service';
import { AddEditDesignPageDescriptionComponent } from '../../../../admin360/customization/design-pages/add-edit-design-page-description/add-edit-design-page-description.component';
import { EFormViewerModalComponent } from '../../../../shared-components/e-forms/e-form-viewer/e-form-viewer-modal/e-form-viewer-modal.component';
import { cloneDeep, orderBy } from 'lodash';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'design-page-details',
    templateUrl: './design-page-details.component.html',
    styleUrls: ['./design-page-details.component.css']
})
export class DesignPageDetailsComponent implements OnInit, OnDestroy {

    // @Input() userDefinedPages: CustomDesignPage[] = [];
    private _userDefinedPages: CustomDesignPage[];
    public get userDefinedPages(): CustomDesignPage[] {
        return this._userDefinedPages;
    }
    @Input() public set userDefinedPages(value: CustomDesignPage[]) {
        this._userDefinedPages = value;
        this.loadTable();
    }
    @Input() designPageID = 0;
    @Input() userCanEdit = false;
    @Input() allowViewEdit = false;
    @Input() singlePageMode = false;
    @Output() updateBasePageEvent = new EventEmitter<any>();
    @Output() designPageUpdated = new EventEmitter<boolean>();

    private subscriptions: Subscription[] = [];
    columnsToDisplay: string[] = [ 'Description', 'AddedBy', 'AddedOn', 'LastUpBy', 'LastUpOn', 'Status'];
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    dataSource: TylerMatTableDataSource;
    config: EFormConfiguration = new EFormConfiguration();
    updateBasePageFlag = false;

    constructor(
        private customizationService: CustomizationService,
        private customizationFrameworkService: CustomizationFrameworkService,
        private eFormService: EFormService,
        private eFormDesignerService: EFormDesignerService,
        private dialog: MatDialog,
        private loginService: LoginService
    ) {

    }

    ngOnInit() {
        this.loadTable();

        this.config.ParentHandlesSave = true;
        this.config.PageFlag = true;
        this.config.CustomFieldsFlag = true;

        if (this.userCanEdit) {
            this.columnsToDisplay.push('Actions');
        }
    }

    ngOnDestroy() {}

    editClick(page: CustomDesignPage) {
        this.customizationFrameworkService.getCustomDataFieldsByObjectID(page.ObjectID).subscribe(results => {
            if (results) {
                this.eFormDesignerService.availableCSTFields = results;
            }
            else {
                this.eFormDesignerService.availableCSTFields = [];
            }
            this.openDesigner(page);
        });
    }

    duplicateClick(page: CustomDesignPage) {
       let pageCopy = cloneDeep(page);
       pageCopy.ID = null;
       pageCopy.Active = false;
       pageCopy.AddedOn = new Date();
       pageCopy.AddedBy = null;
       pageCopy.LastUpOn = null;
       pageCopy.LastUpBy = null;
       const editDescriptionDialog = this.dialog.open(AddEditDesignPageDescriptionComponent, {
        disableClose: true,
        data: {
            page: pageCopy,
            newTemplate: true,
            isDuplicate: true
        }
    });
    editDescriptionDialog.afterClosed().subscribe((p: CustomDesignPage) => {
        if (p) {
            this.editClick(pageCopy);
        }
    });
    }

    viewClick(page: CustomDesignPage) {
        this.customizationFrameworkService.getCustomDataFieldsByObjectID(page.ObjectID).subscribe(results => {
            if (results) {
                this.eFormDesignerService.availableCSTFields = results;
            }
            else {
                this.eFormDesignerService.availableCSTFields = [];
            }
            this.openViewer(page);
        });
    }

    editDescriptionClick(page: CustomDesignPage) {
        const editDescriptionDialog = this.dialog.open(AddEditDesignPageDescriptionComponent, {
            disableClose: true,
            data: {
                page: page,
                newTemplate: false
            }
        });
        editDescriptionDialog.afterClosed().subscribe((p: CustomDesignPage) => {
            if (p) {
                this.customizationService.saveDesignPageTemplate(p).subscribe(result => {
                    this.updateSelectedPage(result);
                });
            }
        });
    }


    getDesignPages() {
        if (this.updateBasePageFlag) {
            this.updateBasePageEvent.emit();
            this.updateBasePageFlag = false;
        }
        else {
            this.subscriptions.push(this.customizationService.getDesignPageByIDs(false, [this.designPageID], true).subscribe(pages => {
                if (this.singlePageMode) {
                    this.userDefinedPages = orderBy(pages, ['BasePage', 'Description'], ['desc', 'asc']);
                    const bp = pages.find(o => o.BasePage);
                    if (bp) {
                      bp.Description = 'System Page';
                    }
                }
                else {
                    this.userDefinedPages = pages.filter(p => !p.BasePage);
                }
                this.loadTable();
            }));
        }
    }

    loadTable() {
        this.dataSource = new TylerMatTableDataSource(this.userDefinedPages);
        this.dataSource.sort = this.sort;
    }

    openDesigner(page: CustomDesignPage = new CustomDesignPage) {
        this.config.Title = page.Name;
        this.config.CSTFieldsManageOwnData = this.loginService.LoginSettings.CustomizationDevMode ? false : true;
        this.eFormService.selectedDesignPage = page;
        this.config.ViewMode = enmEFormViewModes.Page;
        this.config.AllowPages = false;
        this.config.AllowTabs = false;
        this.config.AllowAttachmentControls = false;
        this.config.AllowColumnWidth = true;
        this.config.AllowShowTodayButton = true;
        this.customizationFrameworkService.reconcileChangesToDesignPage(page).pipe(take(1)).subscribe(formData => {
            page.FormData = JSON.stringify(formData);
            page.Version = page.BaseVersion;
            this.eFormService.selectedFormData = formData;
            const dialogRef = this.dialog.open(EFormDesignerComponent, {
                height: '100vh',
                maxHeight: '100vh',
                width: '100vw',
                maxWidth: '100vw',
                disableClose: true,
                autoFocus: false,
                data: { config: this.config, basePage: page.BasePage }
            });

            this.subscriptions.push(dialogRef.componentInstance.saveEvent.subscribe(pageSaved => {
                if (pageSaved == 'save' || pageSaved == 'saveBasePage') {
                    this.customizationService.saveDesignPageTemplate(page).subscribe(result => {
                        // If page is a duplicate, set the ID so a new page isn't created each time save is clicked.
                        if (page.ID == null) {
                            page.ID = result.ID;
                        }
                        this.updateSelectedPage(result);
                        this.eFormService.selectedDesignPage = result;
                        this.designPageUpdated.emit(true);
                        this.getDesignPages();
                    });
                }
            }));
          });
    }

    openViewer(page: CustomDesignPage) {
        this.config.Title = page.Name;
        this.config.CSTFieldsManageOwnData = this.loginService.LoginSettings.CustomizationDevMode ? false : true;
        this.eFormService.selectedDesignPage = page;
        this.config.ViewMode = enmEFormViewModes.Page;
        this.config.AllowPages = false;
        this.config.AllowTabs = false;
        this.config.UseInstance = false;
        this.config.HideLanguageDropDown = true;
        this.customizationFrameworkService.reconcileChangesToDesignPage(page).pipe(take(1)).subscribe(formData => {
            page.FormData = JSON.stringify(formData);
            page.Version = page.BaseVersion;
            this.eFormService.selectedFormData = formData;
            const dialogRef = this.dialog.open(EFormViewerModalComponent, {
                height: '100vh',
                maxHeight: '100vh',
                width: '100vw',
                disableClose: true,
                data: { config: this.config }
            });
        });
    }

    deleteClick(page: CustomDesignPage) {
        if (page.Active) {
            this.updateBasePageFlag = true;
            this.customizationService.toggleActiveDesignPageTemplate(page.ID).subscribe(result => {
                result.DelStatus = true;
                this.customizationService.saveDesignPageTemplate(result).subscribe(() => {
                    this.getDesignPages();
                });
            });
        }
        else {
            page.DelStatus = true;

            const pageIndex: number = this.userDefinedPages.findIndex(p => p.ID == page.ID);
            if (pageIndex > -1) {
                this.userDefinedPages[pageIndex].DelStatus = true;
            }

            if (this.userDefinedPages.filter(p => !p.DelStatus).length == 0) {
                this.updateBasePageFlag = true;
            }

            this.customizationService.saveDesignPageTemplate(page).subscribe(() => {
                this.getDesignPages();
            });
        }
        this.designPageUpdated.emit(true);
    }

    toggleActiveStatusClick(page: CustomDesignPage) {
       if (!this.singlePageMode) {
            //  If the page is being changed from active to inactive then the base page will now be the active page
            //  The base page will need to be updated
            if (page.Active) {
                this.updateBasePageFlag = true;
            }
            //  If no user defined page is active then base page must be active and will need to be updated
            else if (this.userDefinedPages.findIndex(p => (!p.BasePage && p.Active) || (p.BasePage && !p.Active)) == -1) {
                this.updateBasePageFlag = true;
            }
       }

        this.customizationService.toggleActiveDesignPageTemplate(page.ID).pipe(take(1)).subscribe(result => {
            this.getDesignPages();
        });
        this.designPageUpdated.emit(true);
    }

    updateSelectedPage(page: CustomDesignPage) {
        const index: number = this.userDefinedPages.findIndex(p => p.ID == page.ID);
        if (index > -1) {
            this.userDefinedPages[index] = page;
        }
        this.loadTable();
    }

}
